import { render } from "./ClientNotaVentaNueva.vue?vue&type=template&id=1462b8b6&scoped=true"
import script from "./ClientNotaVentaNueva.vue?vue&type=script&lang=js"
export * from "./ClientNotaVentaNueva.vue?vue&type=script&lang=js"

import "./ClientNotaVentaNueva.vue?vue&type=style&index=0&id=1462b8b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1462b8b6"]])

export default __exports__